import React from "react";
import { Box } from "@mui/material";
import { Email } from "@mui/icons-material";
import SocialAuthButtons, { SocialButtonFace } from "./SocialAuthButtons";

// The landing choice on both Login and Register — "Continue with Email"
// sits alongside Google/Apple as an equal option, rather than the email
// form being the default and Google/Apple an afterthought below it.
// Picking email reveals the real form (see LoginPage/RegisterPage's
// `showEmailForm` state); Google/Apple complete the whole sign-in/sign-up
// right from here.
const AuthMethodChooser = ({ onContinueWithEmail }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
    <Box
      component="button"
      type="button"
      onClick={onContinueWithEmail}
      sx={{ p: 0, m: 0, border: 0, width: "100%", background: "none", cursor: "pointer" }}
    >
      <SocialButtonFace icon={<Email sx={{ fontSize: 18, color: "text.secondary" }} />} label="Continue with Email" />
    </Box>

    <SocialAuthButtons />
  </Box>
);

export default AuthMethodChooser;
